import React, { FC } from 'react'
import UserPolaroidList from './UserPolaroidList'

type UserPolaroidsProps = {
  isFiltersVisible?: boolean
}

const UserPolaroids: FC<UserPolaroidsProps> = ({ isFiltersVisible }) => {
  return <UserPolaroidList isFiltersVisible={isFiltersVisible} />
}

export default UserPolaroids
